import { Checkbox, Color, TableCell, TableCellAlign, Tag } from '@isbj-redesign/frontend-components'
import React from 'react'
import AnfragenButton from './AnfragenButton'
import classes from './Dokumente.module.css'
import FileInfo from './FileInfo'
import { useNow } from './hooks'
import TimeRemaining from './TimeRemaining'
import { Dokument } from './types'

export type Props = {
    dokument: Dokument
    selected: Dokument[]
    toggle(dokumente: Dokument[]): void
    remove(dokumente: Dokument[]): void
}

export default function DokumentTableRow({ dokument, selected, toggle, remove }: Props) {
    const gueltig = useDokumentGueltig(dokument)

    return gueltig ? (
        <tr className={`${dokument.heruntergeladen ? '' : classes.new}`}>
            <TableCell fitContent align={TableCellAlign.Middle} className={classes.toggle}>
                <Checkbox
                    label="Eintrag auswählen"
                    onChange={() => toggle([dokument])}
                    checked={selected.some((it) => it.id === dokument.id)}
                    disabled={Boolean(dokument.anfrage)}
                    hideLabel={true}
                />
            </TableCell>
            <TableCell fitContent align={TableCellAlign.Middle}>
                <Tag color={dokument.heruntergeladen ? Color.Light : Color.Info}>{dokument.heruntergeladen ? 'Gelesen' : 'Neu'}</Tag>
            </TableCell>
            <TableCell>
                <FileInfo {...dokument} name={dokument.heruntergeladen ? dokument.name : <strong>{dokument.name}</strong>} />
            </TableCell>
            <TableCell>{dokument.fachverfahren}</TableCell>
            <TableCell>{new Date(dokument.erstelltAm).toLocaleDateString()}</TableCell>
            <TableCell>
                {new Date(dokument.gueltigBis).toLocaleDateString()}
                <br />
                <small>
                    noch <TimeRemaining target={dokument.gueltigBis} />
                </small>
            </TableCell>
            <TableCell>{dokument.downloads}</TableCell>
            <TableCell>
                {dokument.letzterDownload ? (
                    <>
                        {new Date(dokument.letzterDownload.zeitpunkt).toLocaleDateString()}
                        <br />
                        <small>durch {dokument.letzterDownload.benutzerName}</small>
                    </>
                ) : (
                    <em>keiner</em>
                )}
            </TableCell>
            <TableCell fitContent align={TableCellAlign.Middle} className="text-right">
                <AnfragenButton dokumente={[dokument]} options={{ onSuccess: () => remove([dokument]) }} />
            </TableCell>
        </tr>
    ) : null
}

function useDokumentGueltig(dokument: Dokument) {
    return useNow() <= new Date(dokument.gueltigBis).getTime()
}
